import { HStack } from "@/components/ui/hstack";
import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import { Switch } from '@/components/ui/switch';
import i18n from "i18n-js";
import React, { useState, useEffect } from "react";
import FloatingLabelInput from "@/components/basic/FloatingLabelInput";
import ModalFrame from '@/components/basic/ModalFrame';
import { Keyboard } from "react-native";
import { TouchableWithoutFeedback } from "react-native-gesture-handler";

export default function ModalPageSetup({ showModal, setShowModal, format, setFormat, single }) {

    const [actFormat, setActFormat] = useState(format);

    const onClose = (isOk) => {
        setShowModal(false)
        if (isOk) {
            actFormat.p.ml = parseFloat(('' + actFormat.p.ml).replaceAll(',', '.')) || 0
            actFormat.p.mt = parseFloat(('' + actFormat.p.mt).replaceAll(',', '.')) || 0
            actFormat.l.w = parseFloat(('' + actFormat.l.w).replaceAll(',', '.')) || 0
            actFormat.l.dw = parseFloat(('' + actFormat.l.dw).replaceAll(',', '.')) || 0
            actFormat.l.h = parseFloat(('' + actFormat.l.h).replaceAll(',', '.')) || 0
            actFormat.l.dh = parseFloat(('' + actFormat.l.dh).replaceAll(',', '.')) || 0
            actFormat.l.dist = parseFloat(('' + actFormat.l.dist).replaceAll(',', '.')) || 0
            actFormat.l.font = '' + (parseInt(('' + actFormat.l.font)) || '16')
            actFormat.q.s = parseFloat(('' + actFormat.q.s).replaceAll(',', '.')) || 0
            actFormat.q.dist = parseFloat(('' + actFormat.q.dist).replaceAll(',', '.')) || 0
            console.log('FMT', actFormat)
            setFormat(actFormat)
        }
    }

    useEffect(() => {
        setActFormat(format)
    }, [format]);

    return (
        <ModalFrame title='printQRCode.titleSetup' text={single ? 'printQRCode.infoSetupOne' : 'printQRCode.infoSetup'} showModal={showModal} onClose={onClose}>
            <TouchableWithoutFeedback onPress={() => Keyboard.dismiss()}>
            <VStack space='lg' className="items-end">
                <HStack space='xs'>
                    <Text className="text-lg text-secondary-900">{i18n.t('printQRCode.offset')}</Text>
                    <FloatingLabelInput label={i18n.t('printQRCode.left')} w='w-[70]' keyboardType='decimal-pad' autoCorrect={false} value={'' + actFormat.p.ml} onChangeText={num => setActFormat({ ...actFormat, p: { ...actFormat.p, ml: num } })} />
                    <Text className="text-lg text-secondary-900">{' '}</Text>
                    <FloatingLabelInput label={i18n.t('printQRCode.top')} w='w-[70]' keyboardType='decimal-pad' autoCorrect={false} value={'' + actFormat.p.mt} onChangeText={num => setActFormat({ ...actFormat, p: { ...actFormat.p, mt: num } })} />
                </HStack>          
                <HStack space='xs'>
                    <Text className="text-lg text-secondary-900">{i18n.t('printQRCode.label')}</Text>
                    <FloatingLabelInput label={i18n.t('printQRCode.width')} w='w-[70]' keyboardType='decimal-pad' autoCorrect={false} value={'' + actFormat.l.w} onChangeText={num => setActFormat({ ...actFormat, l: { ...actFormat.l, w: num } })} />
                    <Text className="text-lg text-secondary-900">{' x '}</Text>
                    <FloatingLabelInput label={i18n.t('printQRCode.height')} w='w-[70]' keyboardType='decimal-pad' autoCorrect={false} value={'' + actFormat.l.h} onChangeText={num => setActFormat({ ...actFormat, l: { ...actFormat.l, h: num } })} />
                </HStack>
                {!single && <HStack space='xs'>
                    <Text className="text-lg text-secondary-900">{i18n.t('printQRCode.gap')}</Text>
                    <FloatingLabelInput label={i18n.t('printQRCode.width')} w='w-[70]' keyboardType='decimal-pad' autoCorrect={false} value={'' + actFormat.l.dw} onChangeText={num => setActFormat({ ...actFormat, l: { ...actFormat.l, dw: num } })} />
                    <Text className="text-lg text-secondary-900">{' x '}</Text>
                    <FloatingLabelInput label={i18n.t('printQRCode.height')} w='w-[70]' keyboardType='decimal-pad' autoCorrect={false} value={'' + actFormat.l.dh} onChangeText={num => setActFormat({ ...actFormat, l: { ...actFormat.l, dh: num } })} />
                </HStack>}
                <HStack space='xs'>
                    <Text className="text-lg text-secondary-900">{i18n.t('printQRCode.qr')}</Text>
                    <FloatingLabelInput label={i18n.t('printQRCode.size')} w='w-[70]' keyboardType='decimal-pad' autoCorrect={false} value={'' + actFormat.q.s} onChangeText={num => setActFormat({ ...actFormat, q: { ...actFormat.q, s: num } })} />
                    <FloatingLabelInput label={i18n.t('printQRCode.dist')} w='w-[70]' keyboardType='decimal-pad' autoCorrect={false} value={'' + actFormat.q.dist} onChangeText={num => setActFormat({ ...actFormat, q: { ...actFormat.q, dist: num } })} />
                </HStack>
                <HStack space='xs'>
                    <Text className="text-lg text-secondary-900">{i18n.t('printQRCode.font')}</Text>
                    <FloatingLabelInput label={i18n.t('printQRCode.size')} w='w-[70]' keyboardType='decimal-pad' autoCorrect={false} value={'' + actFormat.l.font} onChangeText={num => setActFormat({ ...actFormat, l: { ...actFormat.l, font: num } })} />
                    <FloatingLabelInput label={i18n.t('printQRCode.dist')} w='w-[70]' keyboardType='decimal-pad' autoCorrect={false} value={'' + actFormat.l.dist} onChangeText={num => setActFormat({ ...actFormat, l: { ...actFormat.l, dist: num } })} />
                </HStack>
                <HStack space='xs'>
                    <Text className="text-lg text-secondary-900">{i18n.t('printQRCode.frame')}</Text>
                    <Switch value={actFormat.g.f} onToggle={() => setActFormat({ ...actFormat, g: { ...actFormat.g, f: !actFormat.g.f } })} trackColor={{ false: '#767577', true: '#0071DB' }} thumbColor={ '#FFFFFF' } />
                    <Text className="text-lg text-secondary-900">{i18n.t('printQRCode.ina')}</Text>
                     <Switch value={actFormat.g.i} onToggle={() => setActFormat({ ...actFormat, g: { ...actFormat.g, i: !actFormat.g.i } })} trackColor={{ false: '#767577', true: '#0071DB' }} thumbColor={ '#FFFFFF' } />
                </HStack>
           </VStack>
           </TouchableWithoutFeedback>
        </ModalFrame>
    );
}
